module.exports = __webpack_public_path__ + "static/media/close-circle.685bb035.svg";